<div *ngIf="isLoading"><i class="fa fa-refresh fa-spin mr-1"></i> Cargando...</div>
<div class="formContainer" *ngIf="!isLoading">
  <form (ngSubmit)="fieldForm.form.valid && onSubmit()" #fieldForm="ngForm">
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>Campo</label>
        <input type="text" class="form-control" name="fieldName" [(ngModel)]="model.name" required>
      </div>
      <div class="form-group col-md-4">
        <label>Clasificación</label>
        <select class="form-control" name="classification" [(ngModel)]="model.classificationId" required>
          <option value="">-- Selecccione --</option>
          <option *ngFor="let item of classifications" value={{item.id}}>
            {{item.name}}</option>
        </select>
      </div>
      <div class="form-group col-md-2">
        <label>Hectáreas</label>
        <input type="text" class="form-control" name="hectares" [(ngModel)]="model.hectares">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label>Propietario</label>
        <input type="text" class="form-control" name="owner" [(ngModel)]="model.owner">
      </div>
    </div>
    <div *ngIf="model.id > 0" class="form-row align-items-end">
      <div class="form-group col-md-3">
        <label>Campaña</label>
        <select class="form-control" name="campaign" [(ngModel)]="model.campaignId" (change)="onChangeCampaing()">
          <option *ngFor="let item of campaigns" value={{item.id}}>{{item.name}}</option>
        </select>
      </div>
      <div class="form-group col-md">
        <label>Productor</label>
        <div class="d-flex">
          <p-autoComplete class="flex-grow-1" [(ngModel)]="selectedProducer" name="acProducers"
            [suggestions]="producersResults" [minLength]="2" [inputStyleClass]="'form-control'"
            [panelStyleClass]="'autocompletePanel'" field="nombre"
            [disabled]="selectedProducer !== undefined && selectedProducer !== null"
            (completeMethod)="searchProducers($event)" [forceSelection]="true" (onSelect)="selectProducer($event)"
            (onClear)="clearProducer($event)">
          </p-autoComplete>
          <button *ngIf="selectedProducer !== undefined && selectedProducer !== null" type="button"
            class="btn btn-danger ml-1" (click)="deleteProducer()" title="Eliminar"><i class="fa fa-remove"></i></button>
        </div>
      </div>
      <div class="form-group col-md-auto">
        <div class="form-check control-height">
          <input class="form-check-input" type="checkbox" id="continuationCheck" name="continuation"
            [(ngModel)]="model.continuation">
          <label class="form-check-label" for="continuationCheck">
            ¿Continúa?
          </label>
        </div>
      </div>
    </div>
    <div *ngIf="model.id > 0" class="form-row align-items-end">
      <div class="form-group col-md-4">
        <label>Cultivo</label>
        <select class="form-control" name="crop" [(ngModel)]="model.cropId">
          <option *ngFor="let item of crops" value={{item.id}}>
            {{item.name}}</option>
        </select>
      </div>
      <div class="form-group col-md-2">
        <label>Hectáreas</label>
        <input type="text" class="form-control" name="cropHectare" [(ngModel)]="model.cropHectare">
      </div>
      <div class="form-group col-md-2 control-height">
        <button type="button" class="btn btn-sm btn-success" (click)="saveFieldCrop()" title="Grabar"
          [disabled]="isSaving"><i *ngIf="!isSaving" class="fa fa-plus"></i><i *ngIf="isSaving"
            class="fa fa-refresh fa-spin"></i> Agregar</button>
      </div>
    </div>
    <div *ngIf="fieldCrops?.length > 0" class="form-row">
      <table class="table table-bordered table-sm popUpTableStyle">
        <thead class="thead-dark">
          <tr>
            <th>Campaña</th>
            <th>Cultivo</th>
            <th>Hectáreas</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fieldCrop of fieldCrops">
            <td class="tdAlign">{{fieldCrop.campaignName}}</td>
            <td class="tdAlign">{{fieldCrop.cropName}}</td>
            <td class="tdAlign">{{fieldCrop.hectares}}</td>
            <td class="tdAlign"><button type="button" class="btn btn-sm btn-danger ml-1"
                (click)="deleteFieldCrop(fieldCrop)" title="Eliminar"><i class="fa fa-remove"></i></button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>Sucursal/Agencia</label>
        <select class="form-control" name="branchOffice" [(ngModel)]="model.branchOfficeId" required>
          <option value="">-- Selecccione --</option>
          <option *ngFor="let item of areas" value={{item.id}}>
            {{item.name}}</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label>Operador Comercial</label>
        <select class="form-control" name="advisor" [(ngModel)]="model.advisorId">
          <option value="">-- Selecccione --</option>
          <option *ngFor="let item of advisors" value={{item.id}}>
            {{item.name}}</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <label for="inputAddress">Observaciones</label>
      <textarea style="resize: none;" class="form-control" id="exampleFormControlTextarea1" rows="3" name="observation"
        [(ngModel)]="model.observation"></textarea>
    </div>
    <hr />
    <footer style="float: right;">
      <button type="button" *ngIf="model.id>0" class="btn btn-sm btn-warning ml-1" (click)="onExportPolygon()">
        Poligono
      </button>
      <button type="submit" class="btn btn-sm btn-success ml-1" [disabled]="!fieldForm.valid || isSubmitting">
        <i *ngIf="isSubmitting" class="fa fa-refresh fa-spin"></i> Guardar
      </button>
      <button type="button" *ngIf="model.id>0" class="btn btn-sm btn-danger ml-1" (click)="onDelete(template)">
        Eliminar
      </button>
      <button type="button" class="btn btn-sm btn-danger ml-1" (click)="onCancel()">
        Cerrar
      </button>
    </footer>
  </form>
</div>
<ng-template #template>
  <div class="modal-body text-center">
    <p>Está seguro de eliminar el campo?</p>
    <button type="button" class="btn btn-success" (click)="confirm()">SI</button>
    <button type="button" class="btn btn-primary" (click)="decline()">NO</button>
  </div>
</ng-template>